import { JwtSchema, PasswordSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const SignupRequestSchema = oz.object({
  token: JwtSchema,
  password: PasswordSchema,
}).openapi('SignupRequest');

export type SignupRequestPayload = oz.infer<typeof SignupRequestSchema>;